import { render } from "./OverMijn.vue?vue&type=template&id=0e4fb0d6"
import script from "./OverMijn.vue?vue&type=script&lang=js"
export * from "./OverMijn.vue?vue&type=script&lang=js"
script.render = render

export default script